import React from 'react';

export const XSmall = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    style={{
      fillRule: 'evenodd',
    }}
    {...props}
  >
    <path
      d="M1733.01,523.389L1725.39,531l7.61,7.607-0.39.394-7.61-7.607L1717.39,539l-0.39-.394,7.61-7.607-7.62-7.611,0.4-.395,7.61,7.611,7.61-7.611Z"
      transform="translate(-1717 -523)"
    />
  </svg>
);
